var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuzhen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "04_\u590D\u8BCA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.78,16h-48a4,4,0,0,0-4,4V52a4,4,0,0,0,4,4h48a4,4,0,0,0,4-4V20A4,4,0,0,0,55.78,16Zm0,36h-48V20h48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.52,13.91a2,2,0,0,0,2-2v-4H42.05v4a2,2,0,0,0,4,0v-4a4,4,0,0,0-4-4H21.52a4,4,0,0,0-4,4v4A2,2,0,0,0,19.52,13.91Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.85,38.37h6v6a2,2,0,0,0,4,0v-6h6a2,2,0,0,0,0-4h-6v-6a2,2,0,1,0-4,0v6h-6a2,2,0,0,0,0,4Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuzhen);
export default __webpack_public_path__ + "static/media/fuzhen.9458a565.svg";
export { ForwardRef as ReactComponent };